export function formatAddress(address, number, neighborhood, cityUF, complement) {
    return [
        address,
        number,
        neighborhood,
        cityUF,
        complement
    ].filter(info => info).join(', ');
}